<template>
  <el-sub-menu class='pop-menu' v-for="item in htmls" :index="item.name">
    <template #title>
      <el-popover popper-class="pop-menu-box" placement="right-start" :width="200" trigger="click">
        <template #reference>
          <div :title="item.name" v-if="item.icon"
            style="margin-right:0.5rem ;width: 1.25rem;display: flex;align-items: center;">
            <span v-if="(typeof item.icon === 'string') || (item.icon && item.icon.type === 'iconfont')"
              :class="['iconfont', `icon-${(typeof item.icon === 'string') ? item.icon : item.icon.value}`, 'text-xl']"></span>
            <img class="w-full" v-else :src="item.icon?.value" />
          </div>
          <div  :title="item.name" v-else>{{ item.name[0] }}</div>
        </template>
        <div class="pop-child-menu">
          <div class="menu-section-title">{{ item.name }}</div>
          <div class="menu-section-content">
            <el-menu-item v-for="ele in item.nodes" :index="item.name" @mousedown="handleItemMouseDown(ele)">
              <div
                class="flex justify-start p-2 align-middle transition duration-300 cursor-pointer sidebar_item shrink-0"
                :ref="getSidebarRef" :data-realWidth="ele.width" :data-realHeight="ele.height"
                :data-type="ele.cell.isVertex()">
                <div class="w-12 h-8" v-html="ele.html"></div>
                <span class="leading-8 truncate" :title="ele.code">{{ ele.code }}</span>
              </div>
            </el-menu-item>
            <sidebarDetails v-if="item.children" :htmls="item.children" :get-sidebar-ref="props.getSidebarRef"
              :handle-item-mouse-down="props.handleItemMouseDown" />
          </div>
        </div>
      </el-popover>
    </template>
  </el-sub-menu>
</template>

<script lang="ts">
export default {
  name: 'sidebar-details'
}
</script>
<script setup lang="ts">
import { SidebarHTML, SidebarHTMLItem } from './type/type'
import sidebarDetails from './sidebarDetails.vue'

const props = defineProps<{
  htmls: SidebarHTML[]
  getSidebarRef: (ele: any) => void
  handleItemMouseDown: (item: SidebarHTMLItem) => void
}>()
</script>

<style lang="scss" scoped>
.pop-menu {
  :deep(.el-sub-menu__title) {
    display: flex;
    justify-content: center;
    padding: 0 !important;
    height: 38px !important;

    .el-icon {
      display: none;
    }

    .el-tooltip__trigger {
      margin: 0 !important;
    }
  }
}

.pop-child-menu {
  :deep(.el-menu-item) {
    padding: 0 !important;
    overflow: hidden;
    height: 38px !important;
    color: #666666;
    font-size: 14px;
  }
}
</style>
<style>
.pop-menu-box {
  padding: 0 !important;
  transform: translate(0, -5px);
}

.pop-menu-box .menu-section-title {
  height: 38px;
  padding: 0 20px;
  line-height: 38px;
}
.menu-section-content{
  padding: 0 10px;
}
</style>